import { css } from '@emotion/react'

export const prioritySliderContainer = () => css`
  width: 100%;
  display: flex;
  gap: 16px;
  height: 56px;

  span {
    font-size: 12px;
  }

  p {
    font-size: 12px;
    padding-top: 6px;
  }

  .MuiSlider-mark {
    display: none;
  }

  .MuiSlider-rail {
    height: 8px;
    background-color: #d8d8d8;
    opacity: 1;
  }

  .MuiSlider-track {
    height: 8px;
  }

  .MuiSlider-thumb {
    height: 24px;
    width: 24px;
  }

  .MuiSlider-markLabel {
    top: 36px;
  }
`
